// Notes find constants ::::::::::::::::::::::::

export const NOTES_FIND_REQUEST = "NOTES_FIND_REQUEST";
export const NOTES_FIND_SUCCESS = "NOTES_FIND_SUCCESS";
export const NOTES_FIND_ERR = "NOTES_FIND_ERR";
